export const searchUserResources_actionType = {
    SEARCH_USER_RESOURCES: 'SEARCH_USER_RESOURCES',
    SEARCH_USER_RESOURCES_SUCCESS: 'SEARCH_USER_RESOURCES_SUCCESS',
    SEARCH_USER_RESOURCES_ERROR: 'SEARCH_USER_RESOURCES_ERROR',
    RESET_SEARCH_USER_RESOURCES: 'RESET_SEARCH_USER_RESOURCES'
};